export var TelemetryType;
(function (TelemetryType) {
    TelemetryType["PageviewData"] = "PageviewData";
})(TelemetryType || (TelemetryType = {}));
export var UserAction;
(function (UserAction) {
    UserAction["ButtonClicked"] = "Button Clicked";
    UserAction["Login"] = "Login";
    UserAction["Logout"] = "Logout";
    UserAction["ChangeTheme"] = "Change Theme";
})(UserAction || (UserAction = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["Authenticate"] = "Authenticate";
    ActivityType["Authorise"] = "Authorise";
    ActivityType["Copy"] = "Copy";
    ActivityType["Create"] = "Create";
    ActivityType["Delete"] = "Delete";
    ActivityType["Export"] = "Export";
    ActivityType["Import"] = "Import";
    ActivityType["Move"] = "Move";
    ActivityType["Process"] = "Process";
    ActivityType["Print"] = "Print";
    ActivityType["Restore"] = "Restore";
    ActivityType["Search"] = "Search";
    ActivityType["SoftDelete"] = "SoftDelete";
    ActivityType["Unknown"] = "Unknown";
    ActivityType["Update"] = "Update";
    ActivityType["View"] = "View";
})(ActivityType || (ActivityType = {}));
export var ProductName;
(function (ProductName) {
    ProductName["BLOCKSYNC"] = "BlockSync";
    ProductName["CENTRAL"] = "Central";
    ProductName["EVO"] = "Evo";
    ProductName["UNKNOWN"] = "Unknown";
})(ProductName || (ProductName = {}));
//# sourceMappingURL=metrics.types.js.map